import ReactDOM from "react-dom";
import { ScaleLoader } from "react-spinners";

const ScaleBarrierLoader = ({ text }) => {
  return ReactDOM.createPortal(
    <div className="fixed top-0 left-0 right-0 bottom-0 h-screen w-screen z-[1000] bg-black bg-opacity-70 flex items-center justify-center">
      <div>
        <ScaleLoader
          loading
          color="white"
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        />
        <h1 className="text-white text-3xl mt-20 font-semibold text-center">
          {text}
        </h1>
      </div>
    </div>,
    document.body
  );
};

export default ScaleBarrierLoader;
